import React from "react";
import ReactDOM from "react-dom";
import BaseComponent from "../baseComponent.js";
import DatasetService from "../../core/services/datasetService.js";
import InternalEvent from "../../core/constants/internalEvent.js";
import SearchBox from "./searchBox.jsx";
import Datasets from "./datasets/datasets.jsx";
import Sidenav from "../common/sidenav/sidenav.jsx";
import DatasetDetail from "./dataset-detail/datasetDetail.jsx";
import CreateDataProfile from "./create/dataprofile/createDataProfile.jsx";
import CreateDataset from "./create/dataset/createDataset.jsx";
import styles from "./data-bank.scss";

export default class DataBank extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      searchString: "",
      datasets: [],
      datasetDetail: {
        dataset: null,
        subscriptions: null
      }
    };
    this.resetPaging();
  }

  componentDidMount() {
    this.resolveDependencies()
      .then(() => {
        this.pendingSearch = false;
        // load initial search;
        this.onSearchStringChange("");
      });
    this.subscribe(InternalEvent.Databank.DATASET_CREATED, this.refreshSearch);
  }

  componentWillUnmount() {
    this.unsubscribeAll();
  }

  resolveDependencies() {
    return new Promise((resolve, reject) => {
      try {
        require.ensure([], require => {
          require('../../vendors/jsep/jsep.js');
          require("../../vendors/jquery-mousewheel/jquery.mousewheel.js");
          resolve();
        });
      }
      catch (err) {
        reject(err);
      }
    });
  }

  onDatasetDetailClick(dataset) {
    DatasetService.checkUserDatasetSubscription(dataset.datasetId)
      .then(subscriptions => {
        this.setState({
          datasetDetail: {
            dataset: dataset,
            subscriptions: subscriptions,
          }
        });
        let props = {
          dataset: dataset,
          subscriptions: subscriptions,
          onModalClose: this.handleDetailClosed
        };
        ReactDOM.render(React.createElement(DatasetDetail, props), this.refs.datasetDetailContainer)
      });
  }

  handleDetailClosed() {
    ReactDOM.unmountComponentAtNode(this.refs.datasetDetailContainer);
  }

  resetPaging() {
    this.pagination = {
      pageNumber: 1,
      pageSize: 30,
      isLastPage: false
    };
  }

  onSearchStringChange(searchString) {
    // reset paging for the new search
    this.resetPaging();
    this.findDatasets(this.pagination, searchString, false);
  }

  loadNextDatasetSearchResult() {
    if (this.pagination.isLastPage || this.pendingSearch) {
      this.hidePreloader(1000);
      return;
    }

    let pagingOption = {
      pageNumber: ++this.pagination.pageNumber,
      pageSize: this.pagination.pageSize
    };

    this.findDatasets(pagingOption, this.state.searchString, true);
  }

  refreshSearch() {
    this.findDatasets(this.pagination, this.state.searchString, false);
  }

  findDatasets(pagingOption, searchString, appending) {
    this.showPreloader();
    this.pendingSearch = true;

    // remove virtual dom in order to flipping works
    if (!appending) {
      this.setState({
        datasets: []
      });
    }

    DatasetService.getDataBankDataSetsByName(searchString, pagingOption)
      .then(searchedDatasets => {
        this.pagination.isLastPage = searchedDatasets.length < 15;
        this.pendingSearch = false;
        let newState = {};
        if (appending) {
          newState.datasets = this.state.datasets.concat(searchedDatasets);
        } else {
          newState.datasets = searchedDatasets;
          newState.searchString = searchString;
        }
        this.setState(newState);
        this.hidePreloader(1000);
      });
    window.flipperTimeout = 0;
  }

  openCreateDatasetModal() {
    this.hideSideNav();
    this.refs.createDataset.show();
  }

  openCreateDataProfileModal() {
    this.hideSideNav();
    this.refs.createDataProfile.show();
  }

  showSideNav() {
    this.refs.sideNav.showSideNav();
  }

  hideSideNav() {
    this.refs.sideNav.hideSideNav();
  }

  render() {
    return (
      <div id="data-bank" className={styles.dataBank}>
        <SearchBox onSearchStringChange={(value) => this.onSearchStringChange(value)}/>
        <Datasets datasets={this.state.datasets}
                  nextPage={() => this.loadNextDatasetSearchResult()}
                  onDatasetDetailClick={(dataset) => this.onDatasetDetailClick(dataset)}/>

        <div ref="datasetDetailContainer"></div>
        <CreateDataProfile ref="createDataProfile"/>
        <CreateDataset ref="createDataset"/>
        {
          isMobile() ? null :
            <i className={["icon-plus", styles.datasetCreateBtn].join(" ")} onClick={(e) => this.showSideNav(e)}/>
        }
        <Sidenav ref="sideNav">
          <a className={["waves-effect waves-teal btn-flat", styles.sidenavItem].join(" ")}
             onClick={this.openCreateDatasetModal}>Create Dataset</a>
          <a className={["waves-effect waves-teal btn-flat", styles.sidenavItem].join(" ")}
             onClick={this.openCreateDataProfileModal}>Create Data Profile</a>
        </Sidenav>
        <div id="tooltips-container"></div>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/data-bank/dataBank.jsx